export const GI_SEO_BUS_API = `http://cabs-pagerover.ecs.mmt/gt_bus/api/v1/interlink_bus_seo_data/?page=route`;
export const GI_SEO_RAILS_API = `http://cabs-pagerover.ecs.mmt/gt_rail/api/v1/get_interlink_data/?page=city`;
export const GI_SEO_CABS_API = `http://cabs-pagerover.ecs.mmt/gt_cab/api/v1/cabs_interlinks_data/?page=route`;
export const GI_SEO_HOTELS_API = `http://hotels-gi-seo.ecs.mmt/seo-api/hotels/api/v1/crossLob?lob=FLIGHT&brand=GI&type=name`;
export const GI_OFFERS_API = `http://hotels-goibibocms-pagemaker-web.ecs.mmt/api/v1/pagemaker/get_personalized_chunk_offers_data/?chunk=home_carousel&flavour=mobile&vertical=flight&include_fields=["url","img_url","sub_heading","validity_text","slug"]&mode=app`;
export const GI_OFFERS_API_INTL = `http://hotels-goibibocms-pagemaker-web.ecs.mmt/api/v1/pagemaker/get_chunk_offers_data/?chunk=home_carousel&flavour=v3&vertical=intlflight&include_fields=["url","img_url","sub_heading","validity_text","slug"]&mode=app`;

export const GI_TEMPLATE_CONFIG = {
  flights: {
    templateType: "GI_df_route_template",
    faqTemplate: "GI_df_template",
    faqsTemplate: "faqs_acg_block",
    staticInformation: {
      popularSectorsTitle: { title: "GI-Popular Sectors route" },
      topSectorsTitle: { title: "GI-Top Sectors" },
      popularLongHaulFlightsTitle: { title: "Long_haul_IF_on_DF_Route" },
      intlFlightsFromSourceTitle: { title: "IF Flights from Source" },
      intlFlightsToDestinationTitle: { title: "GI IF Route to Dest" },
      domAirlinesTitle: { title: "GI-Domestic Airlines" },
      topAirlinesTitle: { title: "GI-Operators" },
      udaanSectorsTitle: { title: "GI-Udaan Sectors" },
      offerOverlayTitle: { title: "GI-Offer overlay" },
      flightInfoTitle: { title: "GI-Token-Content" },
      flightInfoTitleGroundUp: { title: "GI-Token-Content-GroundUp" },
    },
    path: ["/flights/:srcCity-to-:destCity-flights/"],
  },
  "hindi-flights": {
    templateType: "GI_hi_df_route_template",
    faqTemplate: "GI_hi_df_route_template",
    staticInformation: {
      topSectorsTitle: null,
      topSectorsFromSourceTitle: {
        title: "GI-Hi-Top Sectors",
        displayTitle: "Top Sectors From ${src_city_name}",
        sectorTitle: "Top Sectors From ${src_city_name}",
      },
      topSectorsToDestinationTitle: {
        title: "GI-Hi-Top Sectors to Dest",
        displayTitle: "Top Sectors From ${dest_city_name}",
      },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: { title: "GI-Token-Content" },
      intlFlightsFromSourceTitle: null,
      intlFlightsToDestinationTitle: null,
    },
    path: ["/flights/hi/:srcCity-to-:destCity-flights/"],
  },
  "international-flights": {
    templateType: "GI_IF_route_template",
    faqTemplate: "GI_Intl_template",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: { title: "GI-IF-Offer overlay" },
      flightInfoTitle: { title: "GI IF Flight Information", wrapContentRequired: true },
      topIntlRoutesTitle: { title: "GI-Route Top International Routes" },
      topIntlCitiesTitle: { title: "GI-Route Top International Cities" },
      ifTemplateLevelContentTitle: {
        title: "IF_Template_level_content",
        wrapContentRequired: true,
      },
    },
    path: [
      "/international-flights/:srcCity-to-:destCity-flights/",
      "/international-flights/:country-cnt-:countryId/:srcCity-to-:destCity-flights/",
    ],
  },
  "hindi-international-flights": {
    templateType: "GI_Hi_IF_route_template",
    faqTemplate: "GI_hi_if_route_template",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: { title: "GI IF Flight Information", wrapContentRequired: true },
      topIntlRoutesTitle: null,
      topIntlCitiesTitle: null,
    },
    path: ["/international-flights/hi/:srcCity-to-:destCity-flights/"],
  },

  "international-flights-to": {
    templateType: "GI_IF_To_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: { title: "GI-IF-to-Flight-Schedule-Offer overlay" },
      flightInfoTitle: null,
      topIntlRoutesTitle: { title: "GI-To-Route Top International Routes", transformToList: true },
      topIntlCitiesTitle: { title: "GI-If to Top International Cities", transformToList: true },
    },
    blocks: [
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        // Cheapest Flight to Destination
        delta: "gi_flights_to_from",
        number_of_links_required: "20",
        weight: 3,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${city_name} Airport Address</h3><div class="fli-sectionbox"><address>${airport_name}<br>Address<br>${airport_address}</address></div></div>',
        weight: 4,
        region: "rightSide",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "All Flights to ${city_name}",
        delta: "gi_flights_to_from_bottom",
        weight: 5,
        count: 45,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
    ],
    path: ["/international-flights/flights-to-:city/"],
  },
  "hindi-international-flights-to": {
    templateType: "GI_hi_IF_to_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
      topIntlRoutesTitle: null,
      topIntlCitiesTitle: null,
    },
    blocks: [
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        // Cheapest Flight to Destination
        delta: "gi_flights_to_from",
        number_of_links_required: "20",
        weight: 3,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${city_name} Airport Address</h3><div class="fli-sectionbox"><address>${airport_name}<br>Address<br>${airport_address}</address></div></div>',
        weight: 4,
        region: "rightSide",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "All Flights to ${hi_city_name}",
        delta: "gi_flights_to_from_bottom",
        weight: 5,
        count: 45,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
    ],
    path: ["/international-flights/hi/flights-to-:city/"],
  },
  "international-flights-from": {
    templateType: "GI_IF_From_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: { title: "GI-IF-from-Flight-Schedule-Offer overlay" },
      flightInfoTitle: null,
      topIntlRoutesTitle: {
        title: "GI-From-Route Top International Routes",
        transformToList: true,
      },
      topIntlCitiesTitle: {
        title: "GI-If from Top International Cities",
        transformToList: true,
      },
    },
    blocks: [
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API_INTL,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        // Cheapest Flight from Destination
        delta: "gi_flights_to_from",
        number_of_links_required: "20",
        weight: 3,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${city_name} Airport Address</h3><div class="fli-sectionbox"><address>${airport_name}<br>Address<br>${airport_address}</address></div></div>',
        weight: 4,
        region: "rightSide",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "All Flights From ${city_name}",
        delta: "gi_flights_to_from_bottom",
        isFlightsFrom: true,
        weight: 5,
        count: 30,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${city_name} (${city_code})",
        delta: "gi_further_flights_to_from_city",
        number_of_links_required: "12",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
    ],
    path: ["/international-flights/flights-from-:city/"],
  },
  "hindi-international-flights-from": {
    templateType: "GI_hi_IF_flights_from_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
      topIntlRoutesTitle: null,
      topIntlCitiesTitle: null,
    },
    blocks: [
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API_INTL,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        // Cheapest Flight from Destination
        delta: "gi_flights_to_from",
        number_of_links_required: "20",
        weight: 3,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${city_name} Airport Address</h3><div class="fli-sectionbox"><address>${airport_name}<br>Address<br>${airport_address}</address></div></div>',
        weight: 4,
        region: "rightSide",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "All Flights From ${hi_city_name}",
        isFlightsFrom: true,
        delta: "gi_flights_to_from_bottom",
        weight: 5,
        count: 30,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${hi_city_name} (${city_code})",
        delta: "gi_further_flights_to_from_city",
        number_of_links_required: "12",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
    ],
    path: ["/international-flights/hi/flights-from-:city/"],
  },

  "flights-to": {
    templateType: "GI_df_flights_to_template",
    faqTemplate: "",
    staticInformation: {
      offerOverlayTitle: { title: "GI_Offer_overlay_flights_to" },
    },
    blocks: [
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        // Cheapest Flight to Destination
        delta: "gi_flights_to_from",
        number_of_links_required: "8",
        weight: 3,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${city_name} Airport Address</h3><div class="fli-sectionbox"><address>${airport_name}<br>Address<br>${airport_address}</address></div></div>',
        weight: 4,
        region: "rightSide",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "All Flights to ${city_name}",
        delta: "gi_flights_to_from_bottom",
        weight: 5,
        count: 30,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/flights-to-:city/"],
  },
  "hindi-flights-to": {
    templateType: "GI_hi_df_to_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
    },
    blocks: [
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        // Cheapest Flight to Destination
        delta: "gi_flights_to_from",
        number_of_links_required: "8",
        weight: 3,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${city_name} Airport Address</h3><div class="fli-sectionbox"><address>${airport_name}<br>Address<br>${airport_address}</address></div></div>',
        weight: 4,
        region: "rightSide",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "All Flights to ${city_name}",
        delta: "gi_flights_to_from_bottom",
        weight: 5,
        count: 30,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/hi/flights-to-:city/"],
  },
  "flights-from": {
    templateType: "GI_df_flights_from_template",
    faqTemplate: "",
    staticInformation: {
      offerOverlayTitle: { title: "GI_Offer_overlay_flights_from" },
    },
    blocks: [
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        // Cheapest Flight to Destination
        delta: "gi_flights_to_from",
        number_of_links_required: "8",
        weight: 3,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${city_name} Airport Address</h3><div class="fli-sectionbox"><address>${airport_name}<br>Address<br>${airport_address}</address></div></div>',
        weight: 4,
        region: "rightSide",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "All Flights From ${city_name}",
        delta: "gi_flights_to_from_bottom",
        weight: 5,
        count: 30,
        isFlightsFrom: true,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${city_name}()",
        delta: "gi_flights_to_from_left",
        weight: 2,
        count: 45,
        region: "rightSidebar",
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/flights-from-:city/"],
  },
  "hindi-flights-from": {
    templateType: "GI_hi_df_flights_from_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
    },
    blocks: [
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        // Cheapest Flight to Destination
        delta: "gi_flights_to_from",
        number_of_links_required: "8",
        weight: 3,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${city_name} Airport Address</h3><div class="fli-sectionbox"><address>${airport_name}<br>Address<br>${airport_address}</address></div></div>',
        weight: 4,
        region: "rightSide",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "All Flights From ${city_name}",
        delta: "gi_flights_to_from_bottom",
        weight: 5,
        count: 30,
        isFlightsFrom: true,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${city_name}()",
        delta: "gi_flights_to_from_left",
        weight: 2,
        count: 45,
        region: "rightSidebar",
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/hi/flights-from-:city/"],
  },

  distance: {
    templateType: "GI_df_distance_template",
    faqTemplate: "FAQ_Distance_template_GI",
    staticInformation: {},
    path: ["/flights/:srcCity-to-:destCity-distance/"],
    blocks: [
      {
        delta: "distance_block",
        api_url:
          "<div class='content ch-append_top10'> <div class='section_box append_bottom10'><h3>${src_city_name} to ${dest_city_name}</h3> <div class='append_bottom10'> <div class='table-responsive'> <table class='table'> <thead> <tr> <th>Aerial Distance</th> <td>${aerial_distance}Km</td></tr></thead> <tbody> <tr> <th>Road Distance</th> <td>${distance}Km</td></tr></tbody> </table> </div></div></div></div>",
        weight: 0,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
      {
        api_url:
          "<section class='clearfix append-bottom20' style='margin-bottom: 20px;'><div id = 'map'></div></section>",
        weight: 0,
        region: "leftSidebar",
        data_source: "CustomHTML",
        delta: "df_distance_map_block",
      },
      {
        title: "${src_city_name} ${dest_city_name} Cheap Flights",
        delta: "gi_fare_table",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
        wrapContentRequired: true,
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentBottom",
        api_url: "",
      },
      {
        api_url: "<div><h2>${src_city_name} to ${dest_city_name} Flight Distance</h1> <div>The easy availability of flights have made travelling from ${src_city_name} to ${dest_city_name} easier than before. Now you can cover the distance of ${aerial_distance} kms of aerial distance within a few hours with regular ${src_city_name} to ${dest_city_name} flights operating on daily basis. There are more than 30+ total no. flights between ${src_city_name} to ${dest_city_name}that operate on regular basis, thus providing easy, fast and secure travel options to millions of travellers going to and fro between the two cities.</div><br/> <h2>${src_city_name} To ${dest_city_name} Road Distance</h2><div> While flights are definitely a most loved mode of transport between ${src_city_name} and ${dest_city_name} for quicker travel. There are still people who love their long road trips and prefer to take a road trip to ${src_city_name} either through their private vehicle or through the buses. The total on-road distance between ${src_city_name} To ${dest_city_name} is ${road_distance} and it took more than a day to reach ${dest_city_name} From ${src_city_name} when travelling via road and not taking any breaks in between. There are several bus operators for this route providing daily buses leaving rom different bus hailing points from ${src_city_name}.</div><br/> <h2>${src_city_name} To ${dest_city_name} Train Distance</h2> <div>Train is another popular mode of travel between ${src_city_name} and ${dest_city_name} and is common among people who are either unable to afford flight tickets or were unable to book a last minute ticket and had to take a train for their impending journey. The train distance between ${src_city_name} to ${dest_city_name} is same as the road distance, whoever the travel time will be a little lesser for trains as compared to the road.</div></div>",
        weight: 0,
        region: "contentBottom",
        data_source: "CustomHTML",
        wrapContentRequired: true,
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "leftSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        title: "Further Distance From ${src_city_name} (${src_city_code})",
        delta: "gi_distance_from_src",
        number_of_links_required: "20",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Distance From ${dest_city_name} (${dest_city_code})",
        delta: "gi_distance_from_dest",
        number_of_links_required: "20",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "20",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "20",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_hotels_seo_block",
        api_url: GI_SEO_HOTELS_API + "&source=${src_city_name}&destination=${dest_city_name}",
        region: "leftSidebar",
        number_of_links_required: 10,
        data_source: "Get",
      },
      {
        title: "about_city",
        delta: "about_city",
        region: "contentBottom",
        data_source: "ACG",
        weight: 3,
      },
    ],
  },

  "airline-schedule": {
    templateType: "GI_df_route_airline_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: { title: "GI-Top Sectors route airline" },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: { title: "GI-Operators" },
      popularSectorsTitle: null,
      offerOverlayTitle: { title: "GI_Offer_overlay_route _airline" },
      flightInfoTitle: null,
    },
    blocks: [
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "leftSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "about_city",
        delta: "about_city",
        region: "contentBottom",
        data_source: "ACG",
        weight: 3,
      },
      {
        api_url:
          '<div class="content_blocks"><h3>About ${airline_name}</h3><div class="fli-sectionbox">${about_airline_text}</div></div>',
        weight: 4,
        region: "contentBottom",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_hotels_seo_block",
        api_url: GI_SEO_HOTELS_API + "&source=${src_city_name}&destination=${dest_city_name}",
        region: "leftSidebar",
        number_of_links_required: 10,
        data_source: "Get",
      },
    ],
    path: ["/flights/:srcCity-to-:destCity-:airline-airline-schedule/"],
  },
  "hindi-airline-schedule": {
    templateType: "GI_hi_df_route_airline_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      topSectorsFromSourceTitle: { title: "GI-Hi-Top Sectors" },
      topSectorsToDestinationTitle: { title: "GI-Hi-Top Sectors to Dest" },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
    },
    blocks: [
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "leftSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "about_city",
        delta: "about_city",
        region: "contentBottom",
        data_source: "ACG",
        weight: 3,
      },
      {
        delta: "gi_airline_details_block",
        weight: 7,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_hotels_seo_block",
        api_url: GI_SEO_HOTELS_API + "&source=${src_city_name}&destination=${dest_city_name}",
        region: "leftSidebar",
        number_of_links_required: 10,
        data_source: "Get",
      },
    ],
    path: ["/flights/hi/:srcCity-to-:destCity-:airline-airline-schedule/"],
  },
  "international-airline-schedule": {
    templateType: "GI_IF_Route_Airline_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      intlAirlinesTitle: { title: "GI-Route Airlines Top International Airlines" },
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: { title: "GI-IF-Offer-Route Airline overlay" },
      flightInfoTitle: null,
      topIntlRoutesTitle: { title: "GI-Route Airline Top International Routes" },
      topIntlCitiesTitle: { title: "GI-Route Airlines Top International Cities" },
      topIntlRouteAirlinesTitle: { title: "GI-Route Airlines Top International Route Airline" },
    },
    blocks: [
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API_INTL,
        region: "leftSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "about_city",
        delta: "about_city",
        region: "contentBottom",
        data_source: "ACG",
        weight: 3,
      },
      {
        delta: "gi_airline_details_block",
        weight: 7,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_hotels_seo_block",
        api_url: GI_SEO_HOTELS_API + "&source=${src_city_name}&destination=${dest_city_name}",
        region: "leftSidebar",
        number_of_links_required: 10,
        data_source: "Get",
      },
    ],
    path: ["/international-flights/:srcCity-to-:destCity-:airline-airline-schedule/"],
  },
  "hindi-international-airline-schedule": {
    templateType: "GI_hi_if_route_airline_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      intlAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
      topIntlRoutesTitle: null,
      topIntlCitiesTitle: null,
      topIntlRouteAirlinesTitle: null,
    },
    blocks: [
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API_INTL,
        region: "leftSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        title: "about_city",
        delta: "about_city",
        region: "contentBottom",
        data_source: "ACG",
        weight: 3,
      },
      {
        delta: "gi_airline_details_block",
        weight: 7,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_hotels_seo_block",
        api_url: GI_SEO_HOTELS_API + "&source=${src_city_name}&destination=${dest_city_name}",
        region: "leftSidebar",
        number_of_links_required: 10,
        data_source: "Get",
      },
    ],
    path: ["/international-flights/hi/:srcCity-to-:destCity-:airline-airline-schedule/"],
  },

  "flight-schedule": {
    templateType: "GI_df_flight_schedule",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: { title: "GI-Top Sectors flight schedule" },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: { title: "GI-Offer overlay-flight schedule" },
      flightInfoTitle: null,
    },
    blocks: [
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Scheduled Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src_schedule",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Scheduled Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest_schedule",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "leftSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${src_city_name} Airport Contact Info</h3><div class="fli-sectionbox"><address>${src_city_airport_name}<br>Address<br>${src_airport_address}</address></div></div>',
        weight: 4,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${dest_city_name} Airport Contact Info</h3><div class="fli-sectionbox"><address>${dest_city_airport_name}<br>Address<br>${dest_airport_address}</address></div></div>',
        weight: 4,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_hotels_seo_block",
        api_url: GI_SEO_HOTELS_API + "&source=${src_city_name}&destination=${dest_city_name}",
        region: "leftSidebar",
        number_of_links_required: 10,
        weight: 10,
        data_source: "Get",
      },
    ],
    path: ["/flights/:srcCity-to-:destCity-flight-schedule/"],
  },
  "hindi-flight-schedule": {
    templateType: "GI_hi_df_flight_schedule_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      topSectorsFromSourceTitle: { title: "GI-Hi-Top Sectors" },
      topSectorsToDestinationTitle: { title: "GI-Hi-Top Sectors to Dest" },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
    },
    blocks: [
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "leftSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${src_city_name} Airport Contact Info</h3><div class="fli-sectionbox"><address>${src_city_airport_name}<br>Address<br>${src_airport_address}</address></div></div>',
        weight: 4,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${dest_city_name} Airport Contact Info</h3><div class="fli-sectionbox"><address>${dest_city_airport_name}<br>Address<br>${dest_airport_address}</address></div></div>',
        weight: 4,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
    ],
    path: ["/flights/hi/:srcCity-to-:destCity-flight-schedule/"],
  },
  "international-flight-schedule": {
    templateType: "GI_IF_Flight_Schedule_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: { title: "GI-IF-Flight-Schedule-Offer overlay" },
      flightInfoTitle: null,
      topIntlRoutesTitle: { title: "GI-Flight Schedule Top International Routes" },
      topIntlCitiesTitle: { title: "GI-Flight Schedule Top International Cities" },
    },
    blocks: [
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "leftSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${src_city_name} Airport Contact Info</h3><div class="fli-sectionbox"><address>${src_airport_name}<br>Address<br>${src_airport_address}</address></div></div>',
        weight: 4,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${dest_city_name} Airport Contact Info</h3><div class="fli-sectionbox"><address>${dest_airport_name}<br>Address<br>${dest_airport_address}</address></div></div>',
        weight: 4,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
      {
        delta: "gi_hotels_seo_block",
        api_url: GI_SEO_HOTELS_API + "&source=${src_city_name}&destination=${dest_city_name}",
        region: "leftSidebar",
        number_of_links_required: 10,
        weight: 10,
        data_source: "Get",
      },
    ],
    path: [
      "/international-flights/:srcCity-to-:destCity-flight-schedule/",
      "/international-flights/:country-cnt-:countryId/:srcCity-to-:destCity-flight-schedule/",
    ],
  },
  "hindi-international-flight-schedule": {
    templateType: "GI_Hi_IF_Flight_Schedule_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
      topIntlRoutesTitle: null,
      topIntlCitiesTitle: null,
    },
    blocks: [
      {
        title: "Further Flights From ${src_city_name} (${src_city_code})",
        delta: "gi_flights_from_src",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        title: "Further Flights From ${dest_city_name} (${dest_city_code})",
        delta: "gi_flights_from_dest",
        number_of_links_required: "5",
        weight: 2,
        region: "leftSidebar",
        data_source: "Preconfigured",
      },
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentMiddle",
        api_url: "",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "leftSidebar",
        weight: 4,
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${src_city_name} Airport Contact Info</h3><div class="fli-sectionbox"><address>${src_airport_name}<br>Address<br>${src_airport_address}</address></div></div>',
        weight: 4,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
      {
        api_url:
          '<div class="content_blocks"><h3>${dest_city_name} Airport Contact Info</h3><div class="fli-sectionbox"><address>${dest_airport_name}<br>Address<br>${dest_airport_address}</address></div></div>',
        weight: 4,
        region: "leftSidebar",
        data_source: "CustomHTML",
      },
    ],
    path: ["/international-flights/hi/:srcCity-to-:destCity-flight-schedule/"],
  },

  "cheap-flights": {
    templateType: "GI_df_Cheap_flights",
    faqTemplate: "GI_cheap_flights_template",
    faqTitle: "Frequently Asked Questions - About Cheap Flights",
    staticInformation: {
      topSectorsTitle: { title: "GI-Cheap Flights Top Sectors", transformToList: true },
      udaanSectorsTitle: null,
      domAirlinesTitle: { title: "GI-Cheap Flights Domestic Airlines" },
      topAirlinesTitle: null,
      popularSectorsTitle: { title: "GI-Popular Sectors Cheap Flights", transformToList: true },
      offerOverlayTitle: null,
      flightInfoTitle: null,
      cheapFlightsContentTitle: { title: "GI Cheap Flights Content", transformToConent: true },
    },
    blocks: [
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentTop",
        api_url: "",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/cheap-flights/"],
  },

  "student-flight-offers": {
    templateType: "Student_Fare",
    faqFromTemplate: "GI_Student_Fare",
    faqTitle: "Frequently Asked Questions - Student Flight Fares",
    staticInformation: {
      topSectorsTitle: { title: "GI-Cheap Flights Top Sectors", transformToList: true },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: { title: "GI-Popular Sectors Cheap Flights", transformToList: true },
      offerOverlayTitle: null,
      flightInfoTitle: null,
      popularLongHaulFlightsTitle: { title: "Long_haul_IF_on_DF_Route", transformToList: true },
    },
    blocks: [
      {
        delta: "gi_breadcrumb",
        weight: 3,
        region: "contentTop",
        api_url: "",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/student-flight-offers.htm"],
  },

  "armed-forces": {
    templateType: "Armed_Forces",
    faqFromTemplate: "GI_Armed_Forces",
    faqTitle: "Frequently Asked Questions - Armed Forces Discount",
    staticInformation: {
      topSectorsTitle: { title: "GI-Cheap Flights Top Sectors", transformToList: true },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: { title: "GI-Popular Sectors Cheap Flights", transformToList: true },
      offerOverlayTitle: null,
      flightInfoTitle: null,
      popularLongHaulFlightsTitle: { title: "Long_haul_IF_on_DF_Route", transformToList: true },
    },
    blocks: [
      {
        delta: "gi_breadcrumb",
        weight: 3,
        region: "contentTop",
        api_url: "",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/armed-forces.htm"],
  },

  "senior-citizens": {
    templateType: "Senior_Citizen",
    faqFromTemplate: "GI_Senior_Citizen",
    faqTitle: "Frequently Asked Questions - Senior Citizens Airfare",
    staticInformation: {
      topSectorsTitle: { title: "GI-Cheap Flights Top Sectors", transformToList: true },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: { title: "GI-Popular Sectors Cheap Flights", transformToList: true },
      offerOverlayTitle: null,
      flightInfoTitle: null,
      popularLongHaulFlightsTitle: { title: "Long_haul_IF_on_DF_Route", transformToList: true },
    },
    blocks: [
      {
        delta: "gi_breadcrumb",
        weight: 3,
        region: "contentTop",
        api_url: "",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/senior-citizens.htm"],
  },

  "flight-pnr-status": {
    templateType: "flight_pnr_status",
    faqFromTemplate: "GI_flight_pnr_status",
    faqTemplate: "",
    faqTitle: "Frequently Asked Questions - Flight PNR Status",
    staticInformation: {
      topSectorsTitle: { title: "GI-Cheap Flights Top Sectors", transformToList: true },
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: { title: "GI-Popular Sectors Cheap Flights", transformToList: true },
      offerOverlayTitle: null,
      flightInfoTitle: null,
      popularLongHaulFlightsTitle: { title: "Long_haul_IF_on_DF_Route", transformToList: true },
    },
    blocks: [
      {
        delta: "gi_breadcrumb",
        weight: 3,
        region: "contentTop",
        api_url: "",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
    ],
    path: ["/flights/flight-pnr-status.htm"],
  },

  "flight-schedule-routes": {
    templateType: "GI_df_Flight_Schedule_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: null,
      topAirlinesTitle: null,
      popularSectorsTitle: null,
      offerOverlayTitle: null,
      flightInfoTitle: null,
      topDomRoutesTitle: {
        title: "GI-Flight Schedule Domestic Sectors",
        transformToList2: true,
        extraData: {
          region: "contentMiddle",
        },
      },
      topIntlRoutesTitle: {
        title: "GI-Flight Schedule International Sectors",
        transformToList2: true,
      },
    },
    blocks: [
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentTop",
        api_url: "",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
    ],
    path: ["/flight-schedule/"],
  },

  airlines: {
    templateType: "GI_df_airline_template",
    faqTemplate: "",
    staticInformation: {
      topSectorsTitle: null,
      udaanSectorsTitle: null,
      domAirlinesTitle: { title: "GI-Domestic Airlines" },
      topAirlinesTitle: null,
      offerOverlayTitle: { title: "GI_Offer_overlay_airline" },
      flightInfoTitle: null,
    },
    blocks: [
      {
        delta: "gi_breadcrumb",
        weight: 1,
        region: "contentTop",
        api_url: "",
      },
      {
        delta: "gi_offers_block",
        api_url: GI_OFFERS_API,
        region: "rightSidebar",
        number_of_links_required: 5,
        data_source: "Get",
      },
      {
        // h1_header
        delta: "gi_flights_to_from_header",
        weight: 2,
        region: "contentTop",
        api_url: null,
        data_source: "Preconfigured",
      },
      {
        title: "${airline_name} Popular Domestic Routes",
        delta: "gi_cheap_airline_routes",
        number_of_links_required: "8",
        weight: 2,
        region: "contentMiddle",
      },
      {
        delta: "gi_airline_details_block",
        weight: 7,
        region: "contentMiddle",
        data_source: "Preconfigured",
      },
      {
        title: "${airline_name} Domestic Routes",
        delta: "top_routes_domestic",
        number_of_links_required: "10",
        weight: 0,
        region: "rightSidebar",
      },
      {
        title: "${airline_name} International Routes",
        delta: "top_routes_international",
        number_of_links_required: "10",
        weight: 0,
        region: "rightSidebar",
      },
      {
        // Top Domestic Routes
        title: "Top Domestic Routes",
        delta: "top_dom_routes_block",
        number_of_links_required: "10",
        weight: 3,
        region: "rightSidebar",
      },
      {
        // Top International Routes
        title: "Top International Routes",
        delta: "top_intl_routes_block",
        number_of_links_required: "10",
        weight: 4,
        region: "rightSidebar",
      },
    ],
    path: ["/airlines/:airline/"],
  },

  "city-country": {
    templateType: "GI_IF_city_country_template",
    faqTemplate: "FAQ_City_Country_GI",
    path: [
      "/city-country/:srcCity-to-:destCity-flights/",
      "/city-country/:country-cnt-:countryId/:srcCity-to-:destCity-flights/",
    ],
    staticInformation: {
      topCountriesListTitle: { title: "GI Top Countries" },
    },
  },

  "if-sitemap-sectors": {
    sectorsTitle: { title: "IF_Sitemap_Sectors" },
  },
  "if-sitemap-sectors-with-airline": {
    sectorsTitle: { title: "IF_Sitemap_Sectors_With_Airline" },
  },
  "city-country-sectors": {
    sectorsTitle: { title: "GI City Country Sitemap" },
  },
};
